import { createBlockCustomFieldValue } from './create'
import { deleteBlockCustomFieldValue } from './delete'
import { notifyBlockCustomFieldValue } from './notify'
import { updateBlockCustomFieldValue } from './update'

export const blockCustomFieldValues = {
  create: createBlockCustomFieldValue,
  update: updateBlockCustomFieldValue,
  delete: deleteBlockCustomFieldValue,
  notify: notifyBlockCustomFieldValue,
}
